import React, { Component } from "react";
import { firebase } from "../firebase/db";

import StudentDetails from "./studentDetails";
import Modal from "react-bootstrap/Modal";
import SendEmail from "./SendEmail";
import PrintProvider, { Print, NoPrint } from "react-easy-print";
import "./studentDetails.css";
import { withRouter } from "react-router-dom";

class DisData extends Component {
  state = {
    users: null,
    open: false,
    user: null
  };

  componentDidMount() {
    const login = localStorage.getItem("login");
    if (login) {
      var arr = [];
      const fireStore = firebase.firestore();
      fireStore
        .collection("addmissionforms")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            arr.push(doc.data());
          });
          this.setState({ users: arr });
        })
        .catch(err => console.log(err));
    } else {
      this.props.history.push("/login");
    }
  }

  handleAccept = cell => {
    const ref = firebase
      .firestore()
      .collection("addmissionforms")
      .doc(cell);

    ref
      .update({
        status: "Accepted"
      })
      .then(() => {
        window.location.reload();
      })
      .catch(err => console.log(err));
  };
  handleReject = cell => {
    const ref = firebase
      .firestore()
      .collection("addmissionforms")
      .doc(cell);

    ref
      .update({
        status: "Rejected"
      })
      .then(() => {
        window.location.reload();
      })
      .catch(err => console.log(err));
  };

  handleTableClick = cell => {
    const ref = firebase
      .firestore()
      .collection("addmissionforms")
      .doc(cell);
    ref
      .get()
      .then(snapShot => {
        this.setState({ user: snapShot.data(), open: true });
      })
      .catch(err => console.log(err));

    console.log(cell);
  };

  handleModelClose = e => {
    this.setState({ open: false });
  };

  handlePrint = e => {
    window.print();
  };

  render() {
    const renderData =
      this.state.users &&
      this.state.users.map((u, i) => {
        return (
          <tr
            key={u.cell}
            onClick={() => this.handleTableClick(u.cell)}
            style={{ cursor: "pointer" }}
          >
            <th scope="row">{i}</th>
            <td>{u.name}</td>
            <td>{u.cell}</td>
            <td>{u.email}</td>
            <td>{u.course}</td>
            <td>{u.addmissiontype}</td>
            <td>{u.nationality}</td>
            <td>{u.status}</td>
            <td>
              {u && u.status === "Accepted" ? (
                <span></span>
              ) : (
                <div style={{ display: "flex" }}>
                  <button
                    style={{
                      background: "green",
                      border: "2px solid gray",
                      marginLeft: "5px",
                      borderRadius: "5px",
                      color: "#fff"
                    }}
                    onClick={() => this.handleAccept(u.cell)}
                  >
                    Accept
                  </button>
                  <button
                    style={{
                      background: "red",
                      border: "2px solid gray",
                      marginLeft: "5px",
                      borderRadius: "5px",
                      color: "#fff"
                    }}
                    onClick={() => this.handleReject(u.cell)}
                  >
                    Reject
                  </button>
                </div>
              )}
            </td>
          </tr>
        );
      });

    return (
      <PrintProvider>
        <NoPrint>
          <div style={{ marginTop: "20px" }}>
            <SendEmail users={this.state.users} />

            <Print single name="foo">
              {this.state.open ? (
                <div>
                  <StudentDetails user={this.state.user} />
                </div>
              ) : null}
            </Print>
            <div style={{ margin: "28px" }}>
              <table className="table">
                <thead style={{ background: "gray", color: "white" }}>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Email</th>
                    <th scope="col">Course</th>
                    <th scope="col">Type</th>
                    <th scope="col">Taka</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>{renderData}</tbody>
              </table>
            </div>

            {/* <button onClick={this.handleModelClose} className="btn btn-primary">Close</button> Application Sent SucessFully <button onClick={this.handlePrint} className="btn btn-primary">Print</button> */}

            <Modal show={this.state.open} size="lg">
              <Modal.Header style={{ color: "green" }}>
                <button
                  onClick={this.handleModelClose}
                  className="btn btn-primary"
                >
                  Close
                </button>{" "}
                Application Sent SucessFully{" "}
                <button onClick={this.handlePrint} className="btn btn-primary">
                  Print
                </button>{" "}
              </Modal.Header>
              <Modal.Body>
                <StudentDetails user={this.state.user} />
              </Modal.Body>
            </Modal>
          </div>
        </NoPrint>
      </PrintProvider>
    );
  }
}

export default withRouter(DisData);
